import { useCacheQuery } from '../../../hooks/use-cache-query';
import { GetRegistrationRetentionDocument } from '../../types/api/graphql';

/**
 * How many days the server keeps a handled registration before deleting it
 * for good. Undefined until loaded, so callers never show a guessed number.
 */
export function useRegistrationRetention(skip?: boolean) {
  const { data, loading } = useCacheQuery(GetRegistrationRetentionDocument, {
    skip: skip === true,
  });

  return {
    data: data?.registrationRetention,
    loading,
  };
}
